import Vue from 'vue'
import {
  RESET_STATE,
  CHANGE_CAMERAS_PER_ROW,
  UPDATE_PREFER_NO_NAME,
  SET_SITE_MAP_OPEN,
  SET_SITE_MAP_FULLSCREEN,
  SET_SITE_MAP_SELECTED_CAMERA,
  SET_SITE_MAP_PINNED,
} from '@/store/mutation-types'

let initialState = {
  camerasPerRow: 3,
  preferNoName: false,
  showSiteMap: false,
  siteMapFullscreen: false,
  siteMapSelectedCameraId: null,
  siteMapPinned: false,
}

// initial state
const state = Vue.util.extend({}, initialState)

// getters
const getters = {
  camerasPerRow: function (state) {
    return state.camerasPerRow
  },
  preferNoName: function (state) {
    return state.preferNoName
  },
  showSiteMap: function (state) {
    return state.showSiteMap
  },
  siteMapFullscreen: function (state) {
    return state.siteMapFullscreen
  },
  siteMapSelectedCameraId: function (state) {
    return state.siteMapSelectedCameraId
  },
  siteMapPinned: function (state) {
    return state.siteMapPinned
  },
}

// mutations
const mutations = {
  [RESET_STATE]: function (state) {
    for (let f in state) {
      Vue.set(state, f, initialState[f])
    }
  },
  [CHANGE_CAMERAS_PER_ROW]: function (state, data) {
    state.camerasPerRow = parseInt(data)
  },
  [UPDATE_PREFER_NO_NAME]: function (state, data) {
    state.preferNoName = data
  },
  [SET_SITE_MAP_OPEN]: function (state, data) {
    state.showSiteMap = data
    if (!data) state.siteMapFullscreen = false
  },
  [SET_SITE_MAP_FULLSCREEN]: function (state, data) {
    state.siteMapFullscreen = data
  },
  [SET_SITE_MAP_SELECTED_CAMERA]: function (state, cameraId) {
    state.siteMapSelectedCameraId = cameraId
  },
  [SET_SITE_MAP_PINNED]: function (state, data) {
    state.siteMapPinned = data
    if (data) state.showSiteMap = true
  },
}

export default {
  state,
  getters,
  mutations
}
